import React, { useState } from "react";
import "./TechnoAep.css";
import "./TechnoAepDigital.css";
import Hero from "../components/SchoolInnerPageBanner";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;
const BASE = `${baseAPIUrl}assets/techno_aep_digital`;

const data = {
    "Class VIII": {
        Physics: {
            chapters: [
                {
                    name: "Force",
                    studyMaterial: `${BASE}/Physics_VIII_Chpt_01 (Force).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=Q0eW0AgXrfw"
                    ],
                    assignment: `${BASE}/Ass-1_Physics_Force_VIII_27.05.2026.pdf`,
                },
                {
                    name: "Friction",
                    studyMaterial: `${BASE}/Physics_VIII_Chpt_02 (Friction).pdf`,
                    videos: [
                    ],
                    assignment: `${BASE}/Ass_Phy-VIII_Chap-02 (Friction).pdf`,
                },
                {
                    name: "Pressure",
                    studyMaterial: `${BASE}/Physics_VIII_Chpt_03 (Pressure).pdf`,
                    videos: [
                    ],
                    assignment: `${BASE}/Ass_Phy-VIII_Chap-03 (Pressure).pdf`,
                },
            ],
        },
        Chemistry: {
            chapters: [
                {
                    name: "Particulate nature of Matter",
                    studyMaterial: `${BASE}/Chemistry_VIII_Chap_01 (Particulate nature....).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "Nature of Matter",
                    studyMaterial: `${BASE}/Chem_VIII_Chap_02 (Nature of Matter).pdf`,
                    videos: [],
                    assignment: '',
                },
                {
                    name: "Basic Languag of Chemistry",
                    studyMaterial: `${BASE}/Chemistry-VIII_Chapter_04 (Basic Language..).pdf`,
                    videos: [],
                    assignment: '',
                },
            ],
        },
        Mathematics: {
            chapters: [
                {
                    name: "Squares and Squares Roots",
                    studyMaterial: `${BASE}/Math_VIII_Chapter_1 (Squares and Square Roors).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=shzYZis2af4",
                        "https://www.youtube.com/watch?v=0BSrZxmC8SU",
                        "https://www.youtube.com/watch?v=pStorj0TdTU",
                        "https://www.youtube.com/watch?v=hpwL0uDJyqA",
                        "https://www.youtube.com/watch?v=NMFiOpqABdA"
                    ],
                    assignment: `${BASE}/Assignment_Chapter_01_Math-VIII.pdf`,

                },
                {
                    name: "Cube and Cube Roots",
                    studyMaterial: `${BASE}/Math-VII_Chapter_2 (Cube and Cube Roots).pdf`,
                    videos: [
                        "https://youtu.be/yduuiqknAH8?si=UShaw7CvjjEBwiyr",
                        "https://youtu.be/xhmbpc1-t_Y?si=G4WhNN1WJt75ONQ5",
                        "https://youtu.be/rs0hZXpFFqk?si=xuh6wNCYLGIvcTcE"
                    ],
                    assignment: `${BASE}/Ass_Math_VIII_Chap_02 (Cube and Cube Roots).pdf`,
                },
                {
                    name: "Exponent",
                    studyMaterial: `${BASE}/Math-VIII_Chapter_3 (Exponent).pdf`,
                    videos: [
                        "https://youtu.be/1f1Wj0_yGZA?si=TOynq7PwWrizDdok",
                        "https://youtu.be/tiabXkDOH8E?si=t-Ifcsh3c7hbQfIn"
                    ],
                    assignment: `${BASE}/Ass-Math-VIII_Chap_03 (Exponent).pdf`,
                },
                {
                    name: "Quadrilaterals",
                    studyMaterial: `${BASE}/Math-viii_Chapter_05 (Quadrilaterals).pdf`,
                    videos: [
                    ],
                    assignment: `${BASE}/Ass_Math_VIII_Chap-05 (Quadrilatuels).pdf`,
                },
                {
                    name: "Number play",
                    studyMaterial: `${BASE}/Math_viii_Chapter_6 (Number play).pdf`,
                    videos: [
                    ],
                    assignment: `${BASE}/Ass_Math_VIII_Chapter_06.pdf`,
                },
                {
                    name: "Operations on Algebraic Expressions",
                    studyMaterial: `${BASE}/Math_VII_Chap-07 (Operations on Algebraic..).pdf`,
                    videos: [
                    ],
                    assignment: `${BASE}/Ass_Math_VIII_Chapter-7 (Operations on...).pdf`,
                },
                {
                    name: "Ratio and Proportion",
                    studyMaterial: `${BASE}/Math-VIII_Chapter_8 (Ratio and Proportion).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "Percentage and Application",
                    studyMaterial: `${BASE}/Math-VIII_Chapter_9 (Percentage and Application).pdf`,
                    videos: [
                    ],
                    assignment: `${BASE}/Ass_Math_VIII Chapter_09 (Percentage and...).pdf`,
                },
                {
                    name: "Proportional Reasoning",
                    studyMaterial: `${BASE}/Math-VIII_Chap_11 (Proportional Reasoning).pdf`,
                    videos: [
                    ],
                    assignment: `${BASE}/Ass-Math-VIII_Chapter_11 (Proportional ...).pdf`,
                },
                {
                    name: "Explaoring some Geometric Thems",
                    studyMaterial: `${BASE}/Math-VIII_Chapter_12 (Exploring some Geometric Themes).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "Topics in Algebra",
                    studyMaterial: `${BASE}/Math_VIII_Chapter_14 (Topics in Algebra).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "Area",
                    studyMaterial: `${BASE}/Math_VIII_Chapter_15 (Area).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
            ],
        },
        Biology: {
            chapters: [
                {
                    name: "Crop Production",
                    studyMaterial: `${BASE}/Biology-Class-VIII (Crop Production) Chapt-01.pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=SxDN06Ue8ns",
                        "https://www.youtube.com/watch?v=Am8e8B7Bd1U"
                    ],
                    assignment: `${BASE}/Ass_Biology_Chapter-01_Class-viii (Crop production).pdf`,
                },
                {
                    name: "Human Health",
                    studyMaterial: `${BASE}/Biology-VIII_Chapter-2 (Human Health).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "The Invisible Living World",
                    studyMaterial: `${BASE}/Bio-VIII_Chapter-1 (Living World).pdf`,
                    videos: [
                        "https://youtu.be/kGatCHTleSI?si=qRZ7DANKpCP_sy9E"
                    ],
                    assignment: '',
                },
            ],
        }
    },
    "Class IX": {
        Physics: {
            chapters: [
                {
                    name: "Motion",
                    studyMaterial: `${BASE}/Physics_IX_Chapter_1 (Motion).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=XqtU47_CyE0",
                        "https://youtu.be/F7WrJP9ozWk?si=jQvZQ4CqWGssngP0",
                        "https://youtu.be/P06P82N0K-k?si=b8DTWUsBbUG4JEVF",
                        "https://www.youtube.com/watch?v=FzzjOwQeBc4",
                    ],
                    assignment: `${BASE}/Assi_Physics_IX Chpt-2 (Motion).pdf`
                },
                {
                    name: "Force & Laws of Motion",
                    studyMaterial: `${BASE}/Phy-IX_Chapter_02 (force & Laws of Motion).pdf`,
                    videos: [
                        "https://youtu.be/aB_SsHekNJQ?si=hrlzvJ61gEuV6i6R",
                        "https://youtu.be/csBLMmF8wtM?si=lb9XRamKygcyGz6p"
                    ],
                    assignment: `${BASE}/Phy-ix_Ass_Chpt-3 (Force).pdf`,
                },
            ],
        },
        Chemistry: {
            chapters: [
                {
                    name: "Exploring Mixtures and Their Separations",
                    studyMaterial: `${BASE}/Chemistry_IX_Chapter_01 (Exploring Mixture and their Separation).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=zgYELv58AqM",
                        "https://www.youtube.com/watch?v=5iEb8O6anSc",
                        "https://www.youtube.com/watch?v=TkJ9IUlgAvw",
                        "https://www.youtube.com/watch?v=FFJBCfVZ7Rw "
                    ],
                    assignment: `${BASE}/Ass_Chemistry_IX Chapter_01 (Exploring Mixtures....).pdf`
                },
                {
                    name: "Atoms & Molelcules",
                    studyMaterial: `${BASE}/Chem_IX_Chap_02 (Atoms & Molelcules).pdf`,
                    videos: [],
                    assignment: `${BASE}/Ass_Chem-IX-Chap-03 (Atoms & Mole).pdf`
                },
                {
                    name: "Atomic Structure",
                    studyMaterial: `${BASE}/Chem_IX_ (Atomic Structure).pdf`,
                    videos: [],
                    assignment: `${BASE}/Assign_1_IX_Chemistry_(Atomic Structure).pdf`
                },
            ],
        },
        Mathematics: {
            chapters: [
                {
                    name: "Co-ordinate Geometry",
                    studyMaterial: `${BASE}/Math-IX_Chapter_01 (Co-ordinate Geometry).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=-yUcIXf-lxo",
                        "https://www.youtube.com/watch?v=qKQ06jP_v00",
                        "https://www.youtube.com/watch?v=yEV-AhckHpY"
                    ],
                    assignment: `${BASE}/Ass_Math_Class-IX_Chapter_01.pdf`
                },
                {
                    name: "Polynomials",
                    studyMaterial: `${BASE}/Math_IX_Chap_02 (Polynomials).pdf`,
                    videos: [
                        "https://youtu.be/95Ji3Ll9TRg?si=JPTMfGMy5KA25pon",
                        "https://youtu.be/geZ1mUBnatE?si=MHDYLMXQCZmzS2yR",
                        "https://youtu.be/axpR-tRAfhc?si=5cdSwWoAdBTH3Fiw",
                        "https://youtu.be/eaitmB-JzU0?si=zCZ5Cr8zQNA6azVe",
                        "https://youtu.be/Kbc9OIxruCk?si=OOtPPLff0dYLx9gP",
                        "https://youtu.be/rKWtoKGpxRU?si=m-DeGv-T3ECa9tDr"
                    ],
                    assignment: `${BASE}/Math-Class-IX_Chapter_02_(Polynomial).pdf`,
                },
                {
                    name: "Number System",
                    studyMaterial: `${BASE}/Math-IX_Chapter_03 (Number System).pdf`,
                    videos: [
                    ],
                    assignment: `${BASE}/Ass-Math-IX_Chapter_03 (Number System).pdf`,
                },
                {
                    name: "Circles",
                    studyMaterial: `${BASE}/Math_IX__Chap_5 (Circles).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "Introduction to Probality",
                    studyMaterial: `${BASE}/Math_IX_Chapter_07 (Introduction to Probality).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "Introduction to Euclid's Geometry",
                    studyMaterial: `${BASE}/Math-IX_Chap_09 (Introduction...).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "Lines and Angles",
                    studyMaterial: `${BASE}/Math_IX_Chap_10 (Lines and Angles).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "Triangles",
                    studyMaterial: `${BASE}/Math-IX_Chap_11 (Triangles).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "Quadrilaterals",
                    studyMaterial: `${BASE}/Math_IX_Chap_12 (Quadrilaterals).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "Linear Equations",
                    studyMaterial: `${BASE}/Math_IX_Chap_13 (Linear Equations).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "Surface Area and Volume",
                    studyMaterial: `${BASE}/Math_IX_Chapter_14 (Surface Area...).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
                {
                    name: "Statistics",
                    studyMaterial: `${BASE}/Math_IX)Chap_15 (Statistics).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
            ],
        },
        Biology: {
            chapters: [
                {
                    name: "Cell",
                    studyMaterial: `${BASE}/Biology-IX_Chapter_01 (Cell).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=u2S_LoY1RAc",
                        "https://www.youtube.com/watch?v=7cvG7cf5CDw",
                        "https://www.youtube.com/watch?v=lh4XkfqksX8",
                        "https://www.youtube.com/watch?v=LV-LNPDDIA0"
                    ],
                    assignment: `${BASE}/Ass_Biology-IX_Chapter_01(Cell).pdf`
                },
                {
                    name: "Tissue",
                    studyMaterial: `${BASE}/Biology_IX_Chapter_02 (Tissue).pdf`,
                    videos: [
                        "https://youtu.be/QFY1OVjtcYw?si=VYlsF-jEoLKjG-kU",
                        "https://youtu.be/3J5Kt9DFmzw?si=jfEwZ9Xh4C2f9iAQ",
                        "https://youtu.be/5R-xOJbcJVw?si=IUC0IUuMtIbMdcCG",
                        "https://youtu.be/FZqGPIupCZY?si=bRTmsKq776GF1LcM",
                        "https://youtu.be/NHEH2b5hK08?si=xyjQWbZPRm_rWzM4"
                    ],
                    assignment: `${BASE}/Ass_chapter_02_Tissue (Biology)_IX.pdf`,
                },
            ],
        }
    },
    "Class X": {
        Physics: {
            chapters: [
                {
                    name: "Light Ray Optics",
                    studyMaterial: `${BASE}/Physics_Class_X (Light—Ray Optics).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=IbDF3PW-mEk"
                    ],
                    assignment: `${BASE}/Ass_Physics_Class-X_Chap-01_(Light).pdf`
                },
                {
                    name: "Current Electricity",
                    studyMaterial: `${BASE}/Phy_X_Chap-02(Current Electricity).pdf`,
                    videos: [
                    ],
                    assignment: `${BASE}/Ass_Phy_X_Chap-02 (Current electricity).pdf`
                },
                {
                    name: "Electromagnetism",
                    studyMaterial: `${BASE}/Phy_Chpt_03_X_(Electromagnetism).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ],
        },
        Chemistry: {
            chapters: [
                {
                    name: "Chemical Reactions and Equations",
                    studyMaterial: `${BASE}/Chemistry-class-X_Chap-01 (Chemical Reaction...).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=OT1RYx_DuDc'
                    ],
                    assignment: `${BASE}/Ass_Chemistry_-X (Chemical Reactions & Equations).pdf`
                },
                {
                    name: "Acids, Base and Salts",
                    studyMaterial: `${BASE}/Chem_X_Chapter-2 (Acids, Base and Salts.pdf`,
                    videos: [
                        "https://youtu.be/ZGypX9Sxn-c?si=V1CmvBja11P1__Ia"
                    ],
                    assignment: `${BASE}/Ass_Chem_X_Chap-02 (Acids, Bases and Salts).pdf`
                },
                {
                    name: "Mental and Non-Metal",
                    studyMaterial: `${BASE}/Chem_X_Chapter_03 (Mental and Non-Metal).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ],
        },
        Mathematics: {
            chapters: [
                {
                    name: "Real Numbers",
                    studyMaterial: `${BASE}/Mathematics_Class_X Chapter_01 (Real Numbers).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=fsIprz51ziE',
                        'https://www.youtube.com/watch?v=1AAr7bs6HTU',
                        'https://www.youtube.com/watch?v=kbZURXvH7XY'
                    ],
                    assignment: `${BASE}/Ass_Math-Class-X_Chap-01 (Real Number).pdf`
                },
                {
                    name: "Polynomials",
                    studyMaterial: `${BASE}/Math_X_ Chapter_02 (Polynomials).pdf`,
                    videos: [
                        "https://youtu.be/dOGq0Q13Rc8?si=SpE9TNxbZNl3P2Vu",
                        "https://youtu.be/BAgGETCkb0Y?si=AaFl7FZtd01bjagW",
                        "https://youtu.be/6npaGZutluI?si=9RV82V-TXNq9_o87"
                    ],
                    assignment: `${BASE}/Class-X_Ass_Chapter_02_(Polynomiasl).pdf`
                },
                {
                    name: "Pair of Linear Equations in Two Variables",
                    studyMaterial: `${BASE}/Math-X_Chapter_03 (Pair of Linear....).pdf`,
                    videos: [
                        "https://youtu.be/eoRpWxjXvIg?si=IzTduwurLfcO_C1t",
                        "https://youtu.be/hfg6wT1GeGo?si=H7h1hcfRH6NAl548",
                        "https://youtu.be/KDpf0pSzR4E?si=IvymSwGVL7HxPQTV",
                        "https://youtu.be/mYl9N9JiJ4w?si=tR-YM9FPC96G6sfE"
                    ],
                    assignment: `${BASE}/Ass_Math-X-Chap_03 (Pair of Linear Equations).pdf`
                },
                {
                    name: "Quadratic Equations",
                    studyMaterial: `${BASE}/Math-X_Chapter_04 (Quadratic Equations).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Arithmetic & Geometric Progression",
                    studyMaterial: `${BASE}/Math-X_Chap_05 (Arithmetic & Geometric..).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Triangles",
                    studyMaterial: `${BASE}/Math-X_Chap_06 (Triangles).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Co-ordinate Geometry",
                    studyMaterial: `${BASE}/Math-X_Chapter_07 (Co-ordinate Geometry).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Introduction to Trigonometry",
                    studyMaterial: `${BASE}/Math-X_Chap_08 (Introduction to ..).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ],
        },
        Biology: {
            chapters: [
                {
                    name: "Nutrition",
                    studyMaterial: `${BASE}/Biology_Class-X_Chap-01 (Life Process).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=aHvz3-Gr9Xw',
                        'https://www.youtube.com/watch?v=bCAgCIwrP_Y',
                        'https://www.youtube.com/watch?v=ynixWlTtvW8',
                        'https://www.youtube.com/watch?v=TRyHgtLRvWE',
                        'https://www.youtube.com/watch?v=0NNW5IY9uCU',
                        'https://www.youtube.com/watch?v=ghi7UV87PtE'
                    ],
                    assignment: `${BASE}/Ass._Biology_Class-X_Chap-01 (Life Processes).pdf`
                },
                {
                    name: "Control & Coordination",
                    studyMaterial: `${BASE}/Biology-X_Chapter_02 (control & coordination).pdf`,
                    videos: [
                        "https://youtu.be/5HI9zpOx9Ec?si=bjZXLBrnexwziOxH"
                    ],
                    assignment: `${BASE}/Bio-X_Chapter_02 (Asignment)_Control.pdf`
                },
                {
                    name: "How do organisms Reproduce",
                    studyMaterial: `${BASE}/Bio-X_Chapter_03(How do organisms...).pdf`,
                    videos: [
                        "https://youtu.be/Wq281UtKhR0?si=sCP2fSM28JOnLsHl",
                        "https://youtu.be/79Z-webyLOs?si=KxFKkXRJHL2o65rw"
                    ],
                    assignment: `${BASE}/Ass-Bio_Class_X_Chap-03 (How do organisms....).pdf`
                },
                {
                    name: "Heredity and Variation",
                    studyMaterial: `${BASE}/Bio_X_Chapter_04 (Heredity).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Our Environment",
                    studyMaterial: `${BASE}/Bio_X_Chapter_05 (our Environment).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ],
        }
    },
    "Class XI": {
        Physics: {
            chapters: [
                {
                    name: "Units and Measurement",
                    studyMaterial: `${BASE}/Physics_Class-XI_Chap_01 (Units and measurement).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=dpc0_FmSPPY',
                        'https://www.youtube.com/watch?v=lYtBVYlUKJM'
                    ],
                    assignment: `${BASE}/Ass_Physics XI (Units-measur).pdf`
                },
                {
                    name: "Kinemetics",
                    studyMaterial: `${BASE}/Phy-XI_Chapter_02 (Kinemetics).pdf`,
                    videos: [
                        "https://youtu.be/8YsITHvGYsY?si=3PuDKPNqrVMynyrs"
                    ],
                    assignment: `${BASE}/Ass_Phy_XI_Chap-02[Motion (Kenematics)].pdf`
                },
            ]
        },
        Chemistry: {
            chapters: [
                {
                    name: "Some Basic Concepts of Chemistry",
                    studyMaterial: `${BASE}/Chemistry-Class-XI Chapter_01 (Some Basic Concepts of Chemistry).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=NyySP2uq5_o'
                    ],
                    assignment: `${BASE}/Ass_Chemistry_XI (Some Basic Concept of Chemistry).pdf`
                },
                {
                    name: "Structure of Atom",
                    studyMaterial: `${BASE}/Chem-XI_Chapter_02 (Structure of Atom).pdf`,
                    videos: [
                        "https://youtu.be/SIIM1Lvdy7k?si=ncDTCZQPi-uN5RG_"
                    ],
                    assignment: `${BASE}/Ass_Chemistry_XI (Structures of Atom).pdf`
                },
                {
                    name: "Classification of Elements",
                    studyMaterial: `${BASE}/Chemistry_XI_Chap_03_(CLASSIFICATION OF ELEMENTS).pdf`,
                    videos: [
                    ],
                    assignment: ''
                }
            ]
        },
        Mathematics: {
            chapters: [
                {
                    name: "Set",
                    studyMaterial: `${BASE}/Math_XI_Chapter-01 (Set).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=LNqeUVDAaLE',
                        'https://www.youtube.com/watch?v=2gtyyIWUGI4'
                    ],
                    assignment: `${BASE}/Ass_Math-XI (Set).pdf`
                },
                {
                    name: "Relations & Functions",
                    studyMaterial: `${BASE}/Math-XI_Chapter_02 (Relations & Functions).pdf`,
                    videos: [
                        "https://youtu.be/VCwkUAWiqaQ?si=sox7SmCD2-A0_hT0",
                        "https://youtu.be/3YXqZPZs1mo?si=S4QF26PfJ9Dpx-N-",
                        "https://youtu.be/I8JSFPLDGKw?si=hDm7wyMWUPHpa73R",
                        "https://youtu.be/V0t6t6NketA?si=rsvSq9leU-baON2Q",
                        "https://youtu.be/_6Xsu-niuUE?si=-Cto-vqDDxgkn7hk"
                    ],
                    assignment: `${BASE}/Ass_Math-XI Chapter_02 (Relation & Function).pdf`
                },
                {
                    name: "Trigonometric Function",
                    studyMaterial: `${BASE}/Math-XI_Chpt-3 (Trigonometric Function).pdf`,
                    videos: [
                        "https://youtu.be/EgbT6BQY4NE?si=b5VgYcetzxsHtbKx",
                        "https://youtu.be/Y8iqTIMBsZM?si=ym07EswApfZFRJOs"
                    ],
                    assignment: ''
                },
            ]
        },
        Biology: {
            chapters: [
                {
                    name: "Biological Classification",
                    studyMaterial: `${BASE}/Biology-Class-XI Chapter_01 (Biological Classification).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=8dc3eUqa5VU"
                    ],
                    assignment: `${BASE}/Assi_Biology_Class-XI (Biological Classification).pdf`
                },
                {
                    name: "Living World",
                    studyMaterial: `${BASE}/Bio-XI_Chapter_02 (living world).pdf`,
                    videos: [
                        "https://youtu.be/v4COtXmDPK0?si=DQVdhvXZkkRillrU"
                    ],
                    assignment: `${BASE}/Ass_Bio-XI_Chp_01 (The living world).pdf`
                },
                {
                    name: "Plant Kingdom",
                    studyMaterial: `${BASE}/Biology-Class-XI Chapter_03 (Plant Kingdom).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Animal Kingdom",
                    studyMaterial: `${BASE}/Biology_XI_Chapter_04 (Animal Kingdom).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Morphology of flowering plants",
                    studyMaterial: `${BASE}/Biology-XI_Chap_05 (Morphology of flowering plants).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Anatomy of Flowring Plant",
                    studyMaterial: `${BASE}/Bio_XI_Chap_06 (Anatomy of Flowring Plant).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Structure organisation in Animal",
                    studyMaterial: `${BASE}/Bio-XI_Chap_7 (Structure organisation).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Cell the unit of Life",
                    studyMaterial: `${BASE}/Bio-XI_Chapter_08 (Cell the unit of Life).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Biomolecules",
                    studyMaterial: `${BASE}/Bio-XI_Chapter_09 (Biomolecules).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Cell Cycle and Cell Division",
                    studyMaterial: `${BASE}/Bio-XI_Chapt_10 (Cell Cycle and Cell Division).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Photosynthesis in Higher Plants",
                    studyMaterial: `${BASE}/Biology_XI Chapter_11 (Photosynthesis in...).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Respiration in Plants",
                    studyMaterial: `${BASE}/Bio_XI_Chapter_12 (Respiration in Plants).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Plant growth and Development",
                    studyMaterial: `${BASE}/Bio_XI_Chapter_13 (Plant growth and Dev.).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Breathing and Exchange of Gases",
                    studyMaterial: `${BASE}/Bio-XI_Chapter_14 (Breathing and Exchange of Gases).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Body Fluids & Circulation",
                    studyMaterial: `${BASE}/Bio-XI_Chapter_15 (Body Fluids & Circulation).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Excretory Products and Their Elimination",
                    studyMaterial: `${BASE}/Biology_XI_Chapter_16(Excretory...).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Locomotion and Movement",
                    studyMaterial: `${BASE}/Biology-XI_Chapter_17(Locomotion..).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Neural Control and Coordination",
                    studyMaterial: `${BASE}/Bio_XI_Chap_18 (Neural Control...).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Chemical Coordination and Integration",
                    studyMaterial: `${BASE}/Biology_XI_Chapter-19(Chemical..).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ]
        }
    },
    "Class XII": {
        Physics: {
            chapters: [
                {
                    name: "Coulomb's Law",
                    studyMaterial: `${BASE}/Physics_Chpt_01_SM1_XII (Coulomb's Law).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=XUP7OIm3X2s',
                        'https://www.youtube.com/watch?v=NRr38BFvyIw',
                        'https://www.youtube.com/watch?v=AMJJvHFCWkw',
                        'https://www.youtube.com/watch?v=5w2Df0b5joc'
                    ],
                    assignment: `${BASE}/Ass_Physics_XII_(Coulomb's Law).pdf`
                },
                {
                    name: "Electric Field",
                    studyMaterial: `${BASE}/Phy_Chpt_02_XII (Electric Field).pdf`,
                    videos: [],
                    assignment: ''
                },
                {
                    name: "Electric Potential",
                    studyMaterial: `${BASE}/Chpt_03_SM1_XII (Electric Potential).pdf`,
                    videos: [],
                    assignment: ''
                },
            ]
        },
        Chemistry: {
            chapters: [
                {
                    name: "Solution",
                    studyMaterial: `${BASE}/Chemistry-XII _Chapter_01 (Solution).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=Ixlrjfi_3Ng'
                    ],
                    assignment: `${BASE}/Ass_Chemistry-XII_Chap-01 (Solutions).pdf`
                },
                {
                    name: "Electrochemistry",
                    studyMaterial: `${BASE}/Chem_XII_Chapter_02 (Electrochemistry).pdf`,
                    videos: [
                    ],
                    assignment: `${BASE}/Ass_Chem_XII_Chap_02_(Electrochemistry).pdf`
                },
                {
                    name: "Chemical Kinetics",
                    studyMaterial: `${BASE}/Chem_XII Chapter_03 (Chemical Kinetics).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ]
        },
        Mathematics: {
            chapters: [
                {
                    name: "Reations & Functions",
                    studyMaterial: `${BASE}/Math_XII_Chapter_01 (Reations & Functions).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=OFnHvJF8gv0',
                        'https://www.youtube.com/watch?v=aX8L6-IN-hI',
                        'https://www.youtube.com/watch?v=kQ7okcBki6I',
                        'https://www.youtube.com/watch?v=kQ7okcBki6I',
                        'https://www.youtube.com/watch?v=hVSbDtxRQe8',
                        'https://www.youtube.com/watch?v=eWlK6ZrL4j8',
                        'https://www.youtube.com/watch?v=5oLpkb_WSC4',
                        'https://www.youtube.com/watch?v=WVZ4rTESMdE'
                    ],
                    assignment: `${BASE}/Math_XII_Chap-01(Relations & Functions).pdf`
                },
                {
                    name: "Inverse Trigonomitric",
                    studyMaterial: `${BASE}/Math-XII_Chap-02 (inverse Trigonomitric).pdf`,
                    videos: [
                        "https://youtu.be/iMWuPoIHYg0?si=D8XC13-JjE2_U4Vl",
                        "https://youtu.be/sj5wQ1xbIwk?si=YAnHH5gPQ0LIz4fy",
                        "https://youtu.be/8qgpyCf2t8c?si=X2D-ugF4qAL8V2SY",
                        "https://youtu.be/Cv9sGO-1WRw?si=fr4wCMUPDWhz5Jrb",
                        "https://youtu.be/eH4MNz-zhyw?si=Q8efIJ4JQUIc25ed",
                        "https://youtu.be/9K39S6VK6Sg?si=Ycegg-rAzs3Mxphv"
                    ],
                    assignment: '${BASE}/Ass_Math-XII_Chapr_02 (Inverse trigonomitric).pdf'
                },
                {
                    name: "Matrices",
                    studyMaterial: `${BASE}/Math-XII_Chapter_03 (Matrices).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ]
        },
        Biology: {
            chapters: [
                {
                    name: "Sexual Reproduction of Plants",
                    studyMaterial: `${BASE}/Biology-XII_Chap_01(Sexual Reproduction of Plants).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=pQudm6NgsNo',
                        'https://www.youtube.com/watch?v=owfP4Hzkq1w',
                        'https://www.youtube.com/watch?v=1aa0onvEvDo',

                    ],
                    assignment: `${BASE}/Ass_XII_chapter_01(Sexual Reproduction).pdf`
                },
                {
                    name: "Human Reproductive System",
                    studyMaterial: `${BASE}/Bio-XII_Chap_02 (Human Reproductive System).pdf`,
                    videos: [
                        "https://youtu.be/H4QJLlzuDmQ?si=DxUYLR1xM7Rd6zjz",
                        "https://youtu.be/o2t7mVjTLsU?si=oSYFWXvrvjntFUWn",
                        "https://youtu.be/Gz9Eyz7fHSY?si=Ei0zw5I3hhRdDRSD"
                    ],
                    assignment: `${BASE}/Ass_Bio_XII_Chap_02_(Human Reproduction).pdf`
                },
                {
                    name: "Reproductive Health",
                    studyMaterial: `${BASE}/Bio-XII_Chap_03 (Reproductive Health).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Principles of inheritance and variation",
                    studyMaterial: `${BASE}/Bio-XII_Chap_4 (Principles of .....).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Molecular Basis of Inheritance",
                    studyMaterial: `${BASE}/Bio-XII_Chap_05 (Molecular Basis ...).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Evolution",
                    studyMaterial: `${BASE}/Bio_XII_Chapter_06 (Evolution).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Human Health and Disease",
                    studyMaterial: `${BASE}/Bio-XII_Chap_07 (Human Health and Disease).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Microbes in Human Welfare",
                    studyMaterial: `${BASE}/Bio-XII_Chap-8 (Microbs in Human).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Biottechnology: Principle & Process",
                    studyMaterial: `${BASE}/Bio_XII_Chap_09  (Biottechnology ; Principle & Process).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Biottechnology and its Applications",
                    studyMaterial: `${BASE}/Bio-XII_Chap_10 (Biotechnology...).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Organisms and Populations",
                    studyMaterial: `${BASE}/Bio_XII_Chap_11 (Org and Populations).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Ecosystem",
                    studyMaterial: `${BASE}/Bio-XII_Chap_12 (Ecosystem).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
                {
                    name: "Biodiversity & Conservation",
                    studyMaterial: `${BASE}/Bio_XII_Chap_13 (Biodiversity & Conservation).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ]
        }
    },
};

const TechnoAepDigital = () => {

    const [activeClass, setActiveClass] = useState("Class VIII");
    const [activeSubject, setActiveSubject] = useState("Physics");

    const [openVideoIndex, setOpenVideoIndex] = useState(null);

    // CLASS LIST
    const classes = Object.keys(data);

    // SUBJECT LIST BASED ON ACTIVE CLASS
    const subjects = Object.keys(data[activeClass] || {});

    // CHAPTER LIST BASED ON CLASS + SUBJECT
    const chapters =
        data[activeClass]?.[activeSubject]?.chapters || [];

    return (
        <div className="academics-page">

            <Hero image="/pictures/image.jpg" alt="tigps academics" />

            <section>
                <div className="outer-container">

                    {/* CLASS SECTION */}
                    <div className="class-section">

                        {classes.map((cls, index) => (
                            <div
                                key={index}
                                className="class-box"
                                onClick={() => {
                                    setActiveClass(cls);

                                    // AUTO SELECT FIRST SUBJECT
                                    const firstSubject = Object.keys(data[cls])[0];
                                    setActiveSubject(firstSubject);
                                }}
                            >
                                <div
                                    className={`icon-wrapper ${activeClass === cls ? "active" : ""}`}
                                >
                                    <div className="icon">
                                        <img src="/pictures/book.png" alt="book" />
                                    </div>
                                </div>

                                <span>{cls}</span>
                            </div>
                        ))}
                    </div>

                    {/* SUBJECT BUTTONS */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "20px",
                            marginBottom: "40px",
                            flexWrap: "wrap",
                        }}
                    >
                        {subjects.map((subject, index) => (
                            <button className="techno-aep-digital-subject-btn"
                                key={index}
                                onClick={() => setActiveSubject(subject)}
                                style={{
                                    padding: "10px 22px",
                                    border: "1px solid #641320",
                                    background:
                                        activeSubject === subject
                                            ? "#641320"
                                            : "#fff",
                                    color:
                                        activeSubject === subject
                                            ? "#fff"
                                            : "#641320",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                }}
                            >
                                {subject}
                            </button>
                        ))}
                    </div>

                    {/* CHAPTER CARDS */}
                    <div className="master-card">

                        {chapters.length > 0 ? (
                            chapters.map((chapter, index) => (
                                <div className="maths-card" key={index}>

                                    <h3
                                        style={{
                                            fontFamily: "lora",
                                            fontSize: "1.3rem",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {chapter.name}
                                    </h3>

                                    <div className="techno-aep-digital-button-grid">

                                        {/* STUDY MATERIAL */}
                                        <a
                                            href={chapter.studyMaterial}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <button className="techno-aep-digital-btn techno-aep-digital-chapter-btn study-material">
                                                Study Material
                                            </button>
                                        </a>

                                        {/* VIDEO BUTTON */}
                                        <button
                                            className="techno-aep-digital-btn"
                                            onClick={() =>
                                                setOpenVideoIndex(
                                                    openVideoIndex === index
                                                        ? null
                                                        : index
                                                )
                                            }
                                        >
                                            Videos
                                        </button>

                                        {/* VIDEO DROPDOWN */}
                                        <div
                                            className={`techno-aep-digital-video-dropdown ${openVideoIndex === index
                                                ? "show"
                                                : ""
                                                }`}
                                        >
                                            <div className="techno-aep-digital-video-buttons">

                                                {chapter.videos.map(
                                                    (video, vidIndex) => (
                                                        <a
                                                            key={vidIndex}
                                                            href={video}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            <button className="techno-aep-digital-small-btn">
                                                                Video {vidIndex + 1}
                                                            </button>
                                                        </a>
                                                    )
                                                )}

                                            </div>
                                        </div>

                                        {/* ASSIGNMENT */}
                                        <a
                                            href={chapter.assignment}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <button className="techno-aep-digital-btn">
                                                Assignment
                                            </button>
                                        </a>

                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="no-chapter-box">

                                <img
                                    src="/pictures/book.png"
                                    alt="No Chapters"
                                    className="no-chapter-icon"
                                />

                                <h3>No Chapters Available</h3>

                                <p>
                                    Study materials, videos and assignments
                                    will be uploaded soon.
                                </p>

                            </div>
                        )}
                    </div>

                </div>
            </section>

        </div>
    );
};

export default TechnoAepDigital;